import React from 'react';


import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';


function TglButtonGroup({value,name,sColor,onToogleChange,children}) {
// name={name}
    return(
        <ToggleButtonGroup
            size="small"
            color={sColor}
            value={value}
            onChange={onToogleChange}>
            {children}
        </ToggleButtonGroup>
    )
}

export default TglButtonGroup;